export type ErrorWithMessage = {
  message: string;
};

/**
 * A TypeScript type guard to check if an unknown value is an
 * object with a string 'message' property.
 *
 * @param error The unknown value to check.
 * @returns True if the value matches the type, otherwise false.
 */
export const isErrorWithMessage = (
  error: unknown
): error is ErrorWithMessage => {
  return (
    typeof error === "object" &&
    error !== null &&
    "message" in error &&
    typeof error.message === "string"
  );
};
